import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=73901e52&scoped=true&"
import script from "./ImageWidget.vue?vue&type=script&lang=js&"
export * from "./ImageWidget.vue?vue&type=script&lang=js&"
import style0 from "./ImageWidget.vue?vue&type=style&index=0&id=73901e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73901e52",
  null
  
)

export default component.exports